import { StreamData } from 'types/streamData'
import SourceType from 'enums/SourceType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorNameResolver: FieldResolver = (metadata: Metadata) =>
  ({
    authorName:
      metadata.getSourceType() === SourceType.BROADCAST
        ? metadata.getSourceName()
        : metadata.getAuthorName()
  } as StreamData)

export default authorNameResolver
